module.exports = __webpack_public_path__ + "img/fr.2f9befe9.svg";